"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var core_1 = require("@angular/core");
var math_1 = require("./math");
var string_1 = require("./string");
var boolean_1 = require("./boolean");
var collection_1 = require("./collection");
__export(require("./math"));
__export(require("./string"));
__export(require("./boolean"));
__export(require("./collection"));
var NgPipesModule = (function () {
    function NgPipesModule() {
    }
    return NgPipesModule;
}());
NgPipesModule = __decorate([
    core_1.NgModule({
        exports: [
            math_1.MathPipesModule,
            string_1.StringPipesModule,
            boolean_1.BooleanPipesModule,
            collection_1.CollectionPipesModule,
        ]
    }),
    __metadata("design:paramtypes", [])
], NgPipesModule);
exports.NgPipesModule = NgPipesModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-pipes/src/index.js
// module id = 579
// module chunks = 75